import { render, staticRenderFns } from "./ReviewTextarea.vue?vue&type=template&id=5867ed6d&scoped=true"
import script from "./ReviewTextarea.vue?vue&type=script&lang=ts"
export * from "./ReviewTextarea.vue?vue&type=script&lang=ts"
import style0 from "./ReviewTextarea.vue?vue&type=style&index=0&id=5867ed6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5867ed6d",
  null
  
)

export default component.exports